/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addGeneralLookup } from '../fn/lookup-table/add-general-lookup';
import { AddGeneralLookup$Params } from '../fn/lookup-table/add-general-lookup';
import { deleteGeneralLookup } from '../fn/lookup-table/delete-general-lookup';
import { DeleteGeneralLookup$Params } from '../fn/lookup-table/delete-general-lookup';
import { GeneralLookup } from '../models/general-lookup';
import { getGeneralLookup } from '../fn/lookup-table/get-general-lookup';
import { getGeneralLookup_1 } from '../fn/lookup-table/get-general-lookup-1';
import { GetGeneralLookup_1$Params } from '../fn/lookup-table/get-general-lookup-1';
import { GetGeneralLookup$Params } from '../fn/lookup-table/get-general-lookup';
import { getHarvestEventsMap_1 } from '../fn/lookup-table/get-harvest-events-map-1';
import { GetHarvestEventsMap_1$Params } from '../fn/lookup-table/get-harvest-events-map-1';
import { getTimeZones } from '../fn/lookup-table/get-time-zones';
import { GetTimeZones$Params } from '../fn/lookup-table/get-time-zones';
import { updateGeneralLookup } from '../fn/lookup-table/update-general-lookup';
import { UpdateGeneralLookup$Params } from '../fn/lookup-table/update-general-lookup';

@Injectable({ providedIn: 'root' })
export class LookupTableService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getGeneralLookup()` */
  static readonly GetGeneralLookupPath = '/api/lookuptable';

  /**
   * Get General Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGeneralLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneralLookup$Response(params?: GetGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneralLookup>>> {
    return getGeneralLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Get General Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGeneralLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneralLookup(params?: GetGeneralLookup$Params, context?: HttpContext): Observable<Array<GeneralLookup>> {
    return this.getGeneralLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GeneralLookup>>): Array<GeneralLookup> => r.body)
    );
  }

  /** Path part for operation `addGeneralLookup()` */
  static readonly AddGeneralLookupPath = '/api/lookuptable';

  /**
   * Add General Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addGeneralLookup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addGeneralLookup$Response(params: AddGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
    return addGeneralLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Add General Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addGeneralLookup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addGeneralLookup(params: AddGeneralLookup$Params, context?: HttpContext): Observable<GeneralLookup> {
    return this.addGeneralLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralLookup>): GeneralLookup => r.body)
    );
  }

  /** Path part for operation `getHarvestEventsMap_1()` */
  static readonly GetHarvestEventsMap_1Path = '/api/lookuptable/harvestevents';

  /**
   * Get Harvest Events Map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestEventsMap_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsMap_1$Response(params?: GetHarvestEventsMap_1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: any;
}>> {
    return getHarvestEventsMap_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Events Map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestEventsMap_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestEventsMap_1(params?: GetHarvestEventsMap_1$Params, context?: HttpContext): Observable<{
[key: string]: any;
}> {
    return this.getHarvestEventsMap_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: any;
}>): {
[key: string]: any;
} => r.body)
    );
  }

  /** Path part for operation `getTimeZones()` */
  static readonly GetTimeZonesPath = '/api/lookuptable/timezones';

  /**
   * Get Time Zones.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeZones()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeZones$Response(params?: GetTimeZones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getTimeZones(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Time Zones.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeZones$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeZones(params?: GetTimeZones$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getTimeZones$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `getGeneralLookup_1()` */
  static readonly GetGeneralLookup_1Path = '/api/lookuptable/{generalLookupId}';

  /**
   * Get General Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGeneralLookup_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneralLookup_1$Response(params: GetGeneralLookup_1$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
    return getGeneralLookup_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get General Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGeneralLookup_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneralLookup_1(params: GetGeneralLookup_1$Params, context?: HttpContext): Observable<GeneralLookup> {
    return this.getGeneralLookup_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralLookup>): GeneralLookup => r.body)
    );
  }

  /** Path part for operation `updateGeneralLookup()` */
  static readonly UpdateGeneralLookupPath = '/api/lookuptable/{generalLookupId}';

  /**
   * Update General Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGeneralLookup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGeneralLookup$Response(params: UpdateGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
    return updateGeneralLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Update General Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGeneralLookup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGeneralLookup(params: UpdateGeneralLookup$Params, context?: HttpContext): Observable<GeneralLookup> {
    return this.updateGeneralLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralLookup>): GeneralLookup => r.body)
    );
  }

  /** Path part for operation `deleteGeneralLookup()` */
  static readonly DeleteGeneralLookupPath = '/api/lookuptable/{generalLookupId}';

  /**
   * Delete General Lookup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteGeneralLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGeneralLookup$Response(params: DeleteGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
    return deleteGeneralLookup(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete General Lookup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteGeneralLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGeneralLookup(params: DeleteGeneralLookup$Params, context?: HttpContext): Observable<GeneralLookup> {
    return this.deleteGeneralLookup$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralLookup>): GeneralLookup => r.body)
    );
  }

}
